import { normalizeAppRole, normalizeAppRoles } from './role-utils';

/**
 * Roles that may create or change wound evaluations and round workflow data.
 * DON and wound_nurse are deliberately absent: they are report reviewers in
 * this application, with read-only access to wound rounds, QA and reports.
 */
export const WOUND_EVALUATION_AUTHOR_ROLES = [
  'nurse',
  'provider',
  'np',
  'clinical_admin',
  'admin',
  'org_admin',
  'super_admin',
] as const;

export const WOUND_REPORT_ONLY_ROLES = ['don', 'wound_nurse'] as const;

export function normalizedWoundRoles(rawRoles: unknown, rawRole?: unknown): Set<string> {
  const roles = normalizeAppRoles(Array.isArray(rawRoles) ? rawRoles : []);
  const role = normalizeAppRole(rawRole);
  return new Set([...roles, ...(role ? [role] : [])]);
}

export function canAuthorWoundEvaluation(rawRoles: unknown, rawRole?: unknown): boolean {
  const roles = normalizedWoundRoles(rawRoles, rawRole);
  return WOUND_EVALUATION_AUTHOR_ROLES.some((role) => roles.has(role));
}

export function isWoundReportOnly(rawRoles: unknown, rawRole?: unknown): boolean {
  const roles = normalizedWoundRoles(rawRoles, rawRole);
  return !canAuthorWoundEvaluation(rawRoles, rawRole) &&
    WOUND_REPORT_ONLY_ROLES.some((role) => roles.has(role));
}
